<template>
	<div class="documents">

		<banner class="documents__banner header--additive-padding" :backgrounds="bannerBackgroundImage">
		</banner>

		<div class="panel">
			<div class="page-container">
				<div class="grid">
<!--
					<div class="grid__item three-quarters--desk">
-->
					<div class="grid__item">


						<div class="documents__tabs tabs">
							<ul class="grid grid--auto grid--b0" v-if="userAssets.children && userAssets.children.length > 0">
								<li class="grid__item" v-on:click="selectTab('document-centre')">
									<span class="tabs__label" v-bind:class="{ 'tabs__label--active': activeTab == 'document-centre' }">Resource Library</span>
								</li>
								<li class="grid__item" v-on:click="selectTab('your-documents')">
									<span class="tabs__label" v-bind:class="{ 'tabs__label--active': activeTab == 'your-documents' }">Your Documents</span>
								</li>
							</ul>
							<div class="documents__content-wrapper">
								<div class="documents__content tabs__content">

									<div v-if="documentCentreAssets.children && documentCentreAssets.children.length > 0 && activeTab == 'document-centre'" >
										<directory-listing ref="directoryListing" class="manage-documents__directory-listing" :directory="documentCentreAssets" :preselect="initialFolderId" root-name="Resource Library" />
									</div>

									<div v-if="userAssets.children && userAssets.children.length > 0 && activeTab == 'your-documents'">
										<directory-listing ref="userDirectoryListing" class="manage-documents__directory-listing" :directory="userAssets" root-name="Your Documents" />
									</div>

								</div>
							</div>
						</div>

					</div>
<!--
					<mq-layout :mq="['desk']" class="grid__item one-quarter--desk">

						<div class="documents__news">
							<div class="grid grid--s32--desk">
								<div class="grid__item" v-for="(item, index) in news.slice(0, 2)" :key="index">
									<news-overview :news="item" :showSummary="false"></news-overview>
								</div>
							</div>
						</div>

					</mq-layout>
-->
 				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { filter, sortBy } from 'lodash';
//import { filter, find, remove, sortBy } from "lodash";

import Btn from './atoms/Btn'
import Banner from './molecules/Banner'
import NewsOverview from './molecules/NewsOverview'
import DirectoryListing from './organisms/DirectoryListing'

export default {
  name: 'Documents',
	components: {
		Btn,
		Banner,
		NewsOverview,
		DirectoryListing,
	},
  data () {
    return {
			activeTab: 'document-centre',
			documentCentreId: null,
			documentCentreAssets: [],
			userAssets: [],
			bannerBackgroundImage: {},
			news: [],
    }
	},
	props: {
		initialFolderId: [Number, String],
	},
	watch: {
  	'$root.userSelectedRegionKey': function()
  	{
			// this.$root.appImmediateLoading = true;

	  //  	this.getNewsPosts()
   //    .then(success =>
   //    {
			// 	this.$root.appImmediateLoading = false;
   //    });
  	},
	},
	created: function () {
		var self = this;

		self.$api.getDocumentCentreId().then((success) =>
		{
			self.$root.$data.appLoading = false;
			self.documentCentreId = success.data;
			self.refreshDocumentCentreData(self.documentCentreId);
		})
		.catch((error) =>
		{
			console.log(error);
		});

    this.getPageContent();
//		self.getNewsPosts();
	},

	methods: {
  	getPageContent: function()
  	{
			// Get Hero Data
			var params = this.$root.userSelectedRegion ? {
				regions: [
					this.$root.userSelectedRegion.key,
				],
				fallback: true,
			} : {
				fallback: true,
			};

			return this.$api.getDocumentspage(params).then((success) =>
			{
				this.heroData(success.data.content[0]);
			})
			.catch((error) =>
			{
				console.log(error);
			});
  	},
  	heroData(data)
  	{
			var self = this;

			self.bannerBackgroundImage = {
				mob: data.mobileBackgroundImage.link,
				ptab: data.mobileBackgroundImage.link,
				ltab: data.desktopBackgroundImage.link,
				desk: data.desktopBackgroundImage.link,
			};

		},
		// getNewsPosts() {
		// 	var self = this;

		// 	// Get all news posts
		// 	var regions = this.$root.userSelectedRegion ? [this.$root.userSelectedRegion.key] : null;
		// 	return self.$api.getNews(null, null, null, null, null, regions).then((data) => {
		// 		if(data.hasOwnProperty('data')) {
		// 			self.sortNewsFeatured(data);
		// 		}
		// 	}).catch((error) => {
		// 		self.$alert.danger({ message: error.message });
		// 	});
		// },
		// sortNewsFeatured(data) {
		// 	var self = this;
		// 	var newsArray = data.data.results;

		// 	// Filter all posts
		// 	var news = newsArray.filter(self.filterNews);
		// 	news = sortBy(news, ["date"]).reverse();

		// 	self.news = news;

		// },
		// filterNews(item) {
		// 	var self = this;
		// 	var today = new Date();
		// 	var date1 = new Date(item.date);


		// 	// Filter by Status and Date and selected Featured
		// 	return item.status && date1 <= today && item.id;
		// },
		selectTab(slug)
		{
			var self = this;
			self.activeTab = slug;
		},

		refreshDocumentCentreData(directoryId)
		{
			var self = this;

			self.$api.getAssetDirectory(directoryId).then((success) => {
				var assets = [];
				if(success.hasOwnProperty('data') && success.data.length == 1)
				{
					assets = success.data[0];
				}
				self.documentCentreAssets = assets;
			}).catch((error) => {
				console.log(error);
			});

			self.$api.getUserAssetDirectory(self.$root.$data.user.id).then((success) => {
				var assets = [];
				if(success.hasOwnProperty('data') && success.data.length > 0)
				{
					var privateFolder = filter(success.data, {name: '_private'});
					if(privateFolder.length > 0)
					{
						privateFolder = privateFolder[0];
						assets = privateFolder;
					}
				}
				self.userAssets = assets;
			}).catch((error) => {
				console.log(error);
			});
		},

		downloadAsset: function(item)
		{
			var self = this;
			var id = self.isPlainObject(item) && item.hasOwnProperty('id') ? item.id : item;

			self.$api.getAsset(id).then((success) => {
				if(success.data.isZip) {
					window.location.assign(self.$apiPath + '/download/asset/zip/' + parseInt(success.data.id, 10));
				} else {
					window.location.assign(self.$apiPath + '/download/asset/' + parseInt(success.data.id, 10));
				}
			}).catch((error) => {
				console.log(error);
			});
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".documents";
	#{$c}
	{
		@include extend(bgc-pal--lightest-grey);

		&__banner
		{
			min-height: 290px;
			@include media(not-phab) { min-height: 400px; }

			&.banner
			{
				@include extend(vertical-bottom);
				padding: {top: rem(40); bottom: rem(40); }
				@include media(not-phab) { padding: {top: rem(56); bottom: rem(56); } }
			}

			.banner__content
			{
				text-align: center;
			}
		}

		&__content-wrapper
		{
			.directory-listing
			{
				&__body
				{
					@include extend(bgc-pal--white);
					border: 1px solid palette('divider');
					border-radius: 4px;

					@include media(phab)
					{
						padding: rem(40) rem(20);
					}

					@include media(not-phab)
					{
						padding: 0 rem(32) rem(32);
					}
				}
			}
		}

		&__news
		{
			margin-top: rem(64);
		}

		.news-overview
		{
			&__meta-wrapper
			{
				display: flex;
				flex-direction: column-reverse;
			}

			&__title
			{
				margin-top: -2px;
				font-size: rem(20);
				margin-bottom: 4px;
			}

			&__meta
			{
				margin-bottom: 0;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Documents.vue